import React, { Fragment } from 'react'

export const nl2br = (text: string) =>
  text.split('\n').map((item, key) => (
    <Fragment key={`nl2br${key}`}>
      {item}
      <br />
    </Fragment>
  ))
